import React from 'react'

import type { Video } from '../../../../api/videos/types'
import AuthorsLabel from '../AuthorsLabel'
import PlayCircle from '../../../../assets/icons/play-circle.svg?react'
import MetadataLabel from '../MetadataLabel'
import * as dateLib from '../../../../libraries/date'
import ProgressBar from '../VideoProgressBar'
import { Link } from 'react-router-dom'
import { useI18N } from '../../../../libraries/i18n/hook'
import BookmarkButtonContainer from '../../../containers/content/videos/BookmarkButton'

type Props = { courseId: number | string, video: Partial<Video> }
const CourseVideoCard: React.FC<Props> = ({ video, courseId }) => {
  const { t } = useI18N()

  const renderVideoProgress = () => {
    const timeLabel = video.watchTime
      ? <MetadataLabel icon='clock'><span className='font-normal text-gray'>{dateLib.parseSecondsToHoursAndMinutes(video.watchTime)}</span></MetadataLabel>
      : null

    if (!video.userActivity?.watched && !video.userActivity?.currentPlayTime) {
      return timeLabel
    }
    if(video.userActivity?.watched) {
      return <div className='text-deep-green font-normal'><MetadataLabel strokeColor='deep-green' icon='checked'>{t('courses.completed.video')}</MetadataLabel></div>
    }
    return (
      <div className='flex items-center gap-x-3'>
        {timeLabel}
        <div className='relative min-w-[130px] pt-2'>
          <ProgressBar duration={video.watchTime} watched={video.userActivity?.watched} currentPlayTime={video.userActivity?.currentPlayTime} />
        </div>
      </div>
    )
  }

  return (
    <div className='relative border-b-soft-green border-b border-solid'>
      <Link to={`/courses/${courseId}/videos/${video.id}`} className='md:flex p-4 md:p-6'>
        <div className='flex-1 flex gap-x-3 md:gap-x-8'>
          <PlayCircle className='fill-black w-8 h-8 md:w-12 md:h-12' />
          <div className='flex-1 flex flex-col gap-y-2'>
            <p className='line-clamp-1 text-deep-green text-2xs sm:text-xs font-semibold'>{video.type?.name}</p>
            <p className='line-clamp-1 text-black text-xs sm:text-sm font-semibold'>{video.title}</p>
            {video.authors && <div className='text-gray font-normal line-clamp-1'><AuthorsLabel lineClamp={1} strokeColor='gray' authors={video.authors} /></div>}
          </div>
        </div>
        <div className='pt-2 pl-11 md:p-0 md:mt-auto'>
          <div className='text-2xs sm:text-xs block'>
            {renderVideoProgress()}
          </div>
        </div>
      </Link>
      {video.id && (
        <div className='absolute auto end-4 bottom-4 top-auto md:top-6'>
          <BookmarkButtonContainer id={video.id} bookmarked={video.userActivity?.saved} />
        </div>
      )}
    </div>
  )
}

export default CourseVideoCard
